import type { CalendarDate, CalendarValues } from "@uselessdev/datepicker";
import { makeObservable } from "mobx";
import { computedFn } from "mobx-utils";

function toTime(date: CalendarDate | undefined): number | undefined {
  if (date === undefined) return undefined;
  return new Date(date).getTime();
}

export class DatePickerStore {
  constructor() {
    makeObservable(this);
  }

  /**
   * The calendar jumps back to the selected month whenever `value.start` is a
   * new object, so callers passing `new Date(...)` each render reset the month
   * the user navigated to. Keying on timestamps keeps one object per date.
   */
  calendarValue(selected: Date | CalendarValues | undefined): CalendarValues {
    if (selected instanceof Date || selected === undefined) {
      return this.valueFromTimes(toTime(selected), undefined);
    }

    return this.valueFromTimes(toTime(selected.start), toTime(selected.end));
  }

  private valueFromTimes = computedFn(
    (startTime: number | undefined, endTime: number | undefined) => ({
      start: startTime === undefined ? undefined : new Date(startTime),
      end: endTime === undefined ? undefined : new Date(endTime),
    }),
  );
}
